export enum LogType {
   Trace,
   Info,
   Success,
   Warning,
   Error
}



// WEBPACK FOOTER //
// ./src/app/models/definitions/log-type.ts